export const DEFAULT_SEARCH_PLAN_RESULT = {
    aggregations: {
        canUseBenepoint: 0,
        hasBigBath: 0,
        hasCrib: 0,
        hasEsteFacility: 0,
        hasKaraoke: 0,
        hasMassage: 0,
        hasNaturalHotspring: 0,
        hasOpenAirBath: 0,
        hasParkingAvailable: 0,
        hasPoolIndoorOrOutdoor: 0,
        hasSauna: 0,
        hasTableTennis: 0,
        hasTransfer: 0,
        isApartment: 0,
        isBarrierFree: 0,
        isBothBreakfastAndDinner: 0,
        isBusinessHotel: 0,
        isCapsuleHotel: 0,
        isCityHotel: 0,
        isCornerStay: 0,
        isCortage: 0,
        isGamping: 0,
        isGuestHouseHostelDormitory: 0,
        isGuestroom: 0,
        isInternetAllowed: 0,
        isNoMeal: 0,
        isNonSmokingRoom: 0,
        isNotRakuten: 0,
        isOnlyBreakfast: 0,
        isOnlyDinner: 0,
        isPClending: 0,
        isPension: 0,
        isPetOk: 0,
        isRakuten: 0,
        isResortHotel: 0,
        // isRoomWithOpenAirBath: 0,
        isRyokan: 0,
        isSmokRandomFlag: 0,
        isSmokingRoom: 0,
        isSupperRoom: 0,
        isTownist: 0,
        isVillaCondominium: 0,
        japaneseAndWesternRoom: 0,
        japaneseStyleRoom: 0,
        semiDoubleRoom: 0,
        singleRoom: 0,
        twinRoom: 0,
        willBeGrantedWithPoints: 0,
        youshitufive: 0,
        youshitufourth: 0,
        youshitutriple: 0
    },
    currentPage: 0,
    dateAvailableData: null,
    menuNo: null,
    plans: [],
    totalItems: 0,
    totalPages: 0
};